var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgP = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.033,
    height: 25.787,
    viewBox: "0 0 18.033 25.787",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M276.757,340.28a9.015,9.015,0,0,0-9.012,8.839h0v16.948l5.2-8.6a9.017,9.017,0,1,0,3.82-17.184Zm.021,14.9a5.99,5.99,0,1,1,5.99-5.99A5.99,5.99,0,0,1,276.777,355.182Z",
    transform: "translate(-267.74 -340.28)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgP, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/p.fb9a1f39.svg";
export { ForwardRef as ReactComponent };